import { FleetConstantClassCollection } from './FleetConstantClassCollection';
import { FleetDefinition } from './FleetDefinition';

export class CreateFleetDefinitionDialogData {
    fleetDefinitionDefaults?: FleetDefinition;
    fleetConstantClassCollection?: FleetConstantClassCollection;
    appStreamImages?: string[];
}